export const toBase64 = (file: File) => new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
        const result = reader.result as string;
        // Klipp bort typ från sträng och ge endast tillbaka base64
        resolve(result.split(",")[1]);
    };
    reader.onerror = error => reject(error);
});
